import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {AnnouncementsService} from '../../../../services/announcements.service';
import {LocalStorageService} from '../../../../services/local-storage.service';

@Component({
    selector: 'app-right-side',
    templateUrl: './right-side.component.html',
    styleUrls: ['./right-side.component.scss']
})
export class RightSideComponent implements OnInit {
    @Input() user;
    @Input() notifications;
    @Input() loadingChildren;
    loadingRequests: boolean;
    forms: any[] = [];
    announcements: any[] = [];

    constructor(private consentsFormService: ConsentsFormService,
                public router: Router,
                public toastMessagesService: ToastMessagesService,
                private announcementsService: AnnouncementsService,
                private localStorageService: LocalStorageService) {
        this.loadingRequests = false;
    }

    async ngOnInit() {
        try {
            this.loadingRequests = true;
            await this.initPersonalRequests();
            await this.initAnnouncements();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.loadingRequests = false;
        }
    }

    async initPersonalRequests() {
        try {
           this.forms = await this.consentsFormService.getPersonalForms();
        } catch (e) {
            throw e;
        }
    }

    async initAnnouncements() {
        try {
            const currentUser = JSON.parse(this.localStorageService.get('user'));
            await this.announcementsService.getAllAnnouncements(+currentUser.id, false);
            this.announcements = this.announcementsService.announcements || [];
        } catch (e) {
            console.log(e.message);
        }
    }

    async showAnnouncement(notification: any) {
        console.log('[showAnnouncement]', notification);
        // Navigate to announcement display page
        await this.router.navigate(['/home/announcement'], {
            queryParams: {
                id: notification.id,
                unique_id: notification.unique_id,
                title: notification.title
            }
        });
    }

    getBorderStyle(position: number) {
        if (position === 0) {
            return {'border-radius': '5px 5px 0 0'};
        }

        if (this.announcements && position === this.announcements.length - 1) {
            return {'border-radius': '0 0 5px 5px'};
        }
    }

    async showPersonalForm(form: any) {
        // Check if form has been submitted (status = 1 means completed)
        const isCompleted = form.status === 1;
        const inputConfig = {
            edit: !isCompleted, // edit=true for new forms to enable editing
            userId: form.notification_to_parent,
            parentId: form.notification_to_parent, // For initializing parent data
            childId: form.notification_to_parent, // For backward compatibility
            mode: isCompleted, // mode=true for viewing completed, mode=false for editing
            unique_id: form.uniqueId,
            version: 'latest',
            id: form.id,
        };
        console.log('[showPersonalForm] form:', form, 'isCompleted:', isCompleted, 'inputConfig:', inputConfig);
        await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
    }
}
